import React from "react";
import { DocumentLibrary } from "@/components/customer/DocumentLibrary";

export default function Documents() {
  return (
    <DocumentLibrary
      overline="Knowledge Base"
      title="Documents"
      subtitle="Wiring diagrams, technical guides, warranty and other documents your OTM administrator has made available for your caravan."
      excludeType="manual,service_bulletin"
      emptyHint="Your OTM administrator can publish documents here for customers to view."
    />
  );
}
